// extracted by mini-css-extract-plugin
export default {"column":"Column_column_X9iAj","large":"Column_large_MrqvN"};